export default {
  "Dados básicos": [
    "nome_programa",
    "categorias_do_programa",
    "descricao",
    "tipo_instrumento",
    "qualificacao_da_proposta",
  ],
  "Quem se destina": ["programa_atende_a", "estados_habilitados"],
  "Condições de Participação": ["criterios", "observacao"],
  "Cronograma da Oportunidade": [
    "data_disponibilizacao",
    "voluntaria_data_inicio",
    "data_inicio_beneficiario_especifico",
    "emenda_data_inicio",
    "data_fim_beneficiario_especifico",
    "emenda_data_fim",
    "voluntaria_data_fim",
  ],
};
